export default __webpack_public_path__ + "static/media/GothamLight.9cea7310.otf";